import { iconNames } from '@zapier/design-system';
import { COLOR_KEYS } from '../../constants';
export const heroFeaturesConfig = {
    name: 'HeroFeatures',
    category: 'Zapier Sections',
    canHaveChildren: true,
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/32a309e7d7de18875acacb5c915dc99e.svg',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'string',
            enum: [
                COLOR_KEYS.neutral100,
                COLOR_KEYS.zapier,
                COLOR_KEYS.night,
                COLOR_KEYS.moss,
                COLOR_KEYS.neutral800,
            ],
            defaultValue: COLOR_KEYS.neutral100,
        },
        {
            name: 'heading',
            type: 'string',
            defaultValue: 'Example Heading',
            required: true,
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'ctaText',
            type: 'string',
        },
        {
            name: 'ctaOpensIntercom',
            type: 'boolean',
            helperText: 'Controls whether or not the CTA opens the Intercom messenger on click',
        },
        {
            name: 'ctaHref',
            type: 'string',
        },
        {
            name: 'ctaDisclaimer',
            type: 'richText',
        },
        {
            name: 'ctaColor',
            type: 'string',
            enum: ['primary', 'primary-alt', 'primary-dark', 'brand'],
        },
        {
            name: 'openInNewTab',
            helperText: 'Controls whether or not the CTA link opens in a new tab',
            type: 'boolean',
        },
        {
            name: 'label',
            type: 'string',
        },
        {
            name: 'labelIcon',
            type: 'string',
            enum: ['', ...Object.keys(iconNames)],
        },
        {
            name: 'labelColor',
            type: 'string',
            enum: [
                '',
                'info',
                'success',
                'error',
                'warning',
                'white',
                'gray',
                'peach',
                'neutral300',
                'bolt',
                'cream',
            ],
        },
    ],
};
//# sourceMappingURL=config.js.map